// extracted by mini-css-extract-plugin
export default {"customValueField":"custom_values_edit_field_wrapper-module___customValueField___e131392a"};